require('!!raw-loader!/builds/713649/v2/src/index.html');